import { isNodeV2 } from '@vedalib/editor'
import React from 'react'

import type { PreviewMode } from 'services/Store/Project/enums'

import type { INodeV2Props, INodeComponentProps } from '../cource/layout/Node/types'
import Editor from './Editor'
import Preview from './Preview'
import SkeletonNodeV2 from './SkeletonNodeV2'

const NODE_V2_COMPONENTS: Partial<Record<PreviewMode, React.FC<INodeV2Props>>> = {
  editor: Editor,
  skeleton: SkeletonNodeV2,
}

const NodeV2Container: React.FC<INodeComponentProps> = (props) => {
  const { node, parent } = props
  const Component = NODE_V2_COMPONENTS[props.mode.previewMode] || Preview

  if (isNodeV2(node) && (parent === null || isNodeV2(parent))) {
    return <Component {...props} node={node} parent={parent} />
  }
  return null
}

export default React.memo(NodeV2Container)
